import { render } from "./ProjectsWinList.vue?vue&type=template&id=3e5b1e37"
import script from "./ProjectsWinList.vue?vue&type=script&lang=js"
export * from "./ProjectsWinList.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__